import { h } from './element';
import { bindClickoutside, unbindClickoutside } from './event';
import { cssPrefix } from '../config';
import { tf } from '../locale/locale';
import { baseSubFormulas} from '../core/format';

function buildMenuItem(item) {
  return h('div', `${cssPrefix}-dropdown-format-submenu-item`)
    .on('click', () => {
      this.itemClick(item.type);
      this.hide();
    }).on('mouseenter', (evt) => {
      // this.isHide = false;
      this.show(this.selectType);
    })
    .on('mouseleave', (evt) => {
      
    })
    .children(
      item.title(),
      h('div', 'label').child(item.label || '')
    ).addClass(item.parentType);
  
}

function buildMenu() {
  return baseSubFormulas.map(it => buildMenuItem.call(this, it));
}

export default class DropdownFormatSubItem {
	//代码库修改
  constructor(isHide = false) {
    this.subMenuItems = buildMenu.call(this);
		
    this.el = h('div', `${cssPrefix}-dropdown-format-submenu`)
      .children(...this.subMenuItems)
      .hide();
    this.itemClick = () => {};
    this.isHide = isHide;
    this.selectType = '';
  }

  show(type){
    const { el } = this;
    el.show();
    this.isHide = false;
    console.log("show type......",type);
    this.selectType = type;
    this.subMenuItems.forEach(menuItem => {
      if (menuItem.hasClass(type)) {
        console.log("menuItem111......",menuItem);
        menuItem.show();
      } else {
        menuItem.hide()
      }
    });
    // unbindClickoutside(el);
  }

  hide(type) {
    const { el } = this;
    el.hide();
    this.isHide = true;
    // unbindClickoutside(el);
  }

  setPosition(x, y) {
    if (this.isHide) return;
    const { el } = this;
    el.css('left', `${x}px`);
    el.css('top', `${y}px`);
  
    bindClickoutside(el);
  }
}
